import React, { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  GxButton, GxCheckbox,
  GxIcon, GxSpinner
} from '@garpix/garpix-web-components-react';
import { useStoreon } from 'storeon/react';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import styles from './styles/index.module.scss';
import {
  DeleteChecked,
  ExtendCertIcon,
  SendIcon
} from '../../../../assets';
import { NAME_TYPES_CERTIFICATE, SIDE_CERTIFICATE_TITLE, TYPES_CERTIFICATE } from '../../const';
import {
  getCheckedCertificateIds,
  countCheckedCertificates,
  getCertificatesForPrint,
  handleClickIsPrint,
  isOneOfCertificatesBlock
} from '../../helpers';
import ModalTransferCertificate from '../../../Applications/components/ModalTransferCertificate';
import ModalExtendCertificate from '../../../Applications/components/ModalExtendCertificate';
import useModalFlag from '../../../../hooks/useModalFlag';
import ToastPrintCertificate from '../../../../components/ToastPrintCertificate';
import { IPrintValue } from '../../interfaces';

const TableCertificates: FC = () => {
  const { dispatch, certificates, statusLoadCertificates } = useStoreon<State, Events>('certificates', 'certificatesParamsApi', 'statusLoadCertificates');
  const { flag: flagModalTransfer, setModalFlag: setModalModalFlagTransfer } = useModalFlag();
  const { flag: openModalExtend, setModalFlag: setOpenModalExtend } = useModalFlag();
  const [checkedCertificates, setCheckedCertificates] = useState<string[]>([])

  const openExtendCertModal = () => {
    const iDs = getCheckedCertificateIds(certificates.results)
    setCheckedCertificates(iDs)
    setOpenModalExtend();
  };

  const getCertificates = () => {
    dispatch('certificates/get', { page: 1 });
  }

  useEffect(() => {
    getCertificates()
  }, []);

  const count = countCheckedCertificates(certificates.results);
  const isDisable = isOneOfCertificatesBlock(certificates.results)

  const print = async (value: IPrintValue) => {
    const arr = await handleClickIsPrint(getCertificatesForPrint(certificates.results, value));

    toast(<ToastPrintCertificate data={{ arr, type: 1 }}/>, {
      position: 'top-right',
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      data: { arr, type: 1 }
    });
  };

	const extendCertificates = () => {
		const data: Array<{ id: number }> = checkedCertificates.map(( item ) => Object({ id: item }));
		api.certificate.extendCertificates({ certificates: data })
			.then(( res ) => {
				if (res.result === 'success') {
          getCertificates()
					setOpenModalExtend();
				}
			})
			.catch(( e ) => {
        console.error(e);
        toast.error('Нельзя выполнить продление срока для сертификата с таким статусом');
        setOpenModalExtend();
      });
	};

  const getUserName = (userData: any): string | null => {
    const nameArr = []

    if (userData) {
      if (userData.last_name) {
        nameArr.push(userData.last_name)
      }
      if (userData.first_name) {
        nameArr.push(userData.first_name)
      }
      if (userData.patronymic_name) {
        nameArr.push(userData.patronymic_name)
      }
    } else {
      return null;
    }

    return nameArr.join(' ');
  }

  const getUserContacts = (userData: any): string | null => {
    if (userData) {
      if (userData.phone) {
        return userData.phone;
      } 
      if (userData.email) {
        return userData.email;
      }

      return null;
    }
      
    return null;
  }

  return (
    <>
      <div className={styles['wrapper']}>
        <div className={styles['table-header']}>
          <div className={styles['table-header--left_block']}>
            <GxCheckbox
              name="multi-checkbox"
              checked={count !== 0}
              onGx-change={() => dispatch('changeCheckedCertificate/set', count !== 0 ? 'takeOf' : 'all')}
            />
            <span className={styles['count']}>{count}</span>
            <GxButton
              className={styles['btn']}
              disabled={count === 0}
              onClick={() => dispatch('changeCheckedCertificate/set', 'takeOf')}
            >
              <GxIcon className={styles['icon']} src={DeleteChecked}/>
              <span>Снять выделенное</span>
            </GxButton>
            <div className={styles['toolbar']}>
              <GxButton className={styles['btn']} onClick={setModalModalFlagTransfer} disabled={count === 0}>
                <GxIcon className={classNames(styles['icon'], styles['icon--send'])} src={SendIcon}/>
                <span>Действие с сертификатами</span>
              </GxButton>
            </div>
            <div className={styles['toolbar']}>
              <GxButton
                className={styles['btn']}
                onClick={openExtendCertModal}
                disabled={count === 0 || isDisable}
              >
                <GxIcon className={classNames(styles['icon'], styles['icon--send'])} src={ExtendCertIcon}/>
                <span>Продлить сертификат</span>
              </GxButton>
            </div>
          </div>

        </div>

        {statusLoadCertificates ? <div className={styles['info']}><GxSpinner style={{ fontSize: '5rem' }}/></div> :
          <>
            {certificates.results.length === 0 ?
              <div className={styles['info']}>
                <p>
                  Сертификаты отсутствуют
                </p>
              </div>
              :
              <table className={styles['table']}>
                <thead>
                <tr className={styles['table--header-row']}>
                  <th/>
                  <th>
                    Название сертификата
                  </th>
                  <th>
                    Номер-серия
                  </th>
                  <th>
                    Тип сертификата
                  </th>
                  <th>
                    Использовал
                  </th>
                  <th>
                    Партия
                  </th>
                  <th>Дата и время создания</th>
                  <th>Статус</th>
                  <th>Плательщик</th>
                  <th>Цена</th>
                  <th>Действителен до</th>
                </tr>
                </thead>
                <tbody>
                {certificates && certificates.results.map((item: Record<string, any>) => (
                  <tr key={item.id}>
                    <td className={styles['column--checkbox']}>
                      <GxCheckbox name="check" checked={item.flag} onGx-change={() => dispatch('changeCheckedCertificate/set', item.id)}/>
                    </td>
                    <td>{item.title}</td>
                    <td>{`${item.number}${item.series ? '-' : ''}${item.series}`}</td>
                    <td>{SIDE_CERTIFICATE_TITLE[item.side]}</td>
                    <td>
                      {getUserName(item.used_customer)}
                      <br />
                      {getUserContacts(item.used_customer)}
                    </td>
                    <td>{item.party}</td>
                    <td>{item.created_at ? dayjs(item.created_at).format('DD.MM.YYYY HH:mm') : '-'}</td>
                    <td>
                      <span
                        className={
                          classNames(styles['table__item--status'],
                            styles[`table__item--status--${NAME_TYPES_CERTIFICATE[TYPES_CERTIFICATE[item.status]].class}`])
                        }
                      >
                        {NAME_TYPES_CERTIFICATE[TYPES_CERTIFICATE[item.status]].title}
                      </span>
                    </td>
                    <td>
                      {getUserName(item.customer)}
                      <br />
                      {getUserContacts(item.customer)}
                    </td>
                    <td>{`${Math.trunc(item.price_paid).toLocaleString()} руб.`}</td>
                    <td>{item.date_validity ? dayjs(item.date_validity).format('DD.MM.YYYY') : '-'}</td>
                  </tr>
                ))}
                </tbody>
              </table>
            }
          </>
        }
      </div>
      <ModalTransferCertificate
        flag={flagModalTransfer}
        onRequestClose={setModalModalFlagTransfer}
        onSave={print}
        type="print"
      />
      <ModalExtendCertificate
        flag={openModalExtend}
        onRequestClose={setOpenModalExtend}
        onSave={extendCertificates}
        certificateIds={checkedCertificates}
      />
    </>
  );
};

export default TableCertificates;
